import { makeStyles, fade } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  itemsHeader: {
    display: 'flex',
    alignItems: 'center',
    '&:not(.info)': {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    },
    '& h5': {
      whiteSpace: 'nowrap'
    }
  },
  addNewLineBtn: {
    textTransform: 'none',
    marginLeft: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      marginLeft: theme.spacing(0)
    }
  },
  cellDataWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& a': {
      maxWidth: 245,
      width: '100%',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '& span': {
      fontSize: theme.typography.pxToRem(12)
    }
  },
  addNewItemButton: {
    marginTop: theme.spacing(1.5)
  },
  itemsTableWrapper: {
    width: '100%',
    position: 'relative'
  },
  optionWrapper: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  optionContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    marginLeft: theme.spacing(0.5)
  },
  optionParent: {
    color: theme.palette.grey['500'],
    fontWeight: theme.typography.fontWeightSemiBold
  },
  option: {
    color: theme.palette.common.black
  },
  optionID: {
    color: theme.palette.primary.dark,
    fontWeight: theme.typography.fontWeightBold,
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5)
  },
  virtualDeletedItem: {
    backgroundColor: fade(theme.palette.common.black, 0.1),
    '& > td': {
      color: fade(theme.palette.common.black, 0.3)
    }
  },
  currencyTooltip:{
    display: 'inline-block',
    '& button': {
      padding: theme.spacing(0.125),
      minWidth: 'auto'
    }
  }
}))
